import LegalLayout from "@/pages/legal/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Use" eyebrow="// Legal">
      <p>These Terms of Use ("Terms") govern your use of <strong>lucastransinc.com</strong> and any related digital services provided by Lucas Trans Inc. ("we", "us"). By using the site you agree to these Terms.</p>

      <h2>1. Not a binding freight contract</h2>
      <p>Freight quotes, driver applications and messages submitted through this website are <strong>requests for information</strong>. No transportation contract is created until we and the shipper sign a rate confirmation or master transportation agreement.</p>

      <h2>2. Accurate information</h2>
      <p>You agree to submit accurate and current information. Misrepresenting freight, weights, hazardous status, CDL credentials or medical qualifications may result in refusal of service and, for drivers, disqualification from consideration.</p>

      <h2>3. Prohibited use</h2>
      <ul>
        <li>Do not use the website for unlawful purposes, to send spam, or to attempt to breach security.</li>
        <li>Do not submit content that infringes another party&apos;s rights.</li>
        <li>Do not attempt to scrape, reverse-engineer or overwhelm the site.</li>
      </ul>

      <h2>4. Intellectual property</h2>
      <p>The site, the Lucas Trans Inc. name and logo, photography and copy are owned by Lucas Trans Inc. or its licensors. You may not copy, redistribute or use them without written permission.</p>

      <h2>5. Third-party services</h2>
      <p>We rely on third-party services such as Resend (email), MongoDB Atlas (database) and, when enabled, Twilio (SMS). Their availability is not guaranteed and outages may temporarily affect form submissions.</p>

      <h2>6. Disclaimers</h2>
      <p>The site is provided <strong>&quot;as is&quot;</strong> without warranties of any kind, express or implied. We do not warrant that the site will be uninterrupted or error-free.</p>

      <h2>7. Limitation of liability</h2>
      <p>To the maximum extent permitted by law, Lucas Trans Inc. will not be liable for indirect, incidental, special, consequential or punitive damages arising from your use of the website. Our total liability related to the website is limited to USD $100.</p>

      <h2>8. Governing law</h2>
      <p>These Terms are governed by the laws of the State of Illinois, USA, without regard to conflict-of-law rules. Any dispute will be resolved in the state or federal courts located in Cook County, Illinois.</p>

      <h2>9. Changes</h2>
      <p>We may update these Terms; the current version always lives at this URL. Continued use of the site after changes constitutes acceptance.</p>

      <h2>10. Contact</h2>
      <p>Lucas Trans Inc. · Hoffman Estates, Illinois · <a href="mailto:office@lucastransinc.com">office@lucastransinc.com</a></p>

      <p className="text-xs text-slate-500 mt-8">Effective: February 2026</p>
    </LegalLayout>
  );
}
